import { motion } from "framer-motion";

const ease = [0.2, 0.7, 0.1, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.9, delay, ease }}
    >
      {children}
    </M>
  );
};

const lineVariants = {
  hidden: { y: "105%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, delay: d, ease } }),
};

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0.1, inView = false, testId }) => {
  const anim = inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} data-testid={testId} initial="hidden" {...anim}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em]">
          <motion.span className={`block ${lineClass}`} variants={lineVariants} custom={delay + i * 0.11}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
